import { ReactElement } from "react"
import { HamburguerButtonProps } from "./hamburguer-button-props"
import * as S from './hamburguer-button-style'

export function HamburguerButton (props: HamburguerButtonProps): ReactElement {
  return <S.Container {...props}>
    <span></span>
    <span></span>
    <span></span>
  </S.Container>
}
